<template>
  <base-toolbar>
    <BackToFlatplan />
    <v-btn variant="text" :to="{ name: 'category-edit', params: { categoryId: 'new' } }" :prepend-icon="mdiPlus" color="primary">
      <span v-if="!mobile">Add</span>
    </v-btn>
  </base-toolbar>
</template>

<script>
import { inject } from "vue"
import { mdiPlus } from "@mdi/js"

import BackToFlatplan from "@/components/BackToFlatplan"

export default {
  name: "CategoryToolBar",
  components: { BackToFlatplan },
  setup() {
    const mobile = inject("mobile")

    return {
      mobile,
      mdiPlus,
    }
  },
}
</script>

<style lang="scss" scoped></style>
